import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Icon, { GLYPHS } from '../../../../../common/icon';
import InventoryInput from './InventoryInput';

const InventoryCell = ({ row, unallocatedInventory, assignmentValues, shopifySettings }) => {
  const isShopLocation = get(shopifySettings, 'locationId') === row.original.ownerId;
  const isBrandLocation = (get(shopifySettings, 'locationType') === 'brand' && row.original.isTopLevel);
  const showShopifyIcon = isShopLocation || isBrandLocation;

  return (<div className="u-position-relative" data-automation-id="inventory-cell">
    <Icon
      glyph={GLYPHS.shopifyLogo}
      className="o-icon--small shopify-icon"
      display-if={showShopifyIcon}
    />
    {
      row.original.isTopLevel ? (
        <span className="u-type--semibold">
          {unallocatedInventory} total unallocated
        </span>
      ) : (
        <InventoryInput
          row={row}
          assignmentValues={assignmentValues}
          unallocatedInventory={unallocatedInventory}
        />
      )
    }
  </div>);
};

InventoryCell.propTypes = {
  unallocatedInventory: PropTypes.number.isRequired,
  assignmentValues: PropTypes.shape({}).isRequired,
  row: PropTypes.shape({}).isRequired,
  shopifySettings: PropTypes.shape({}).isRequired,
};

export default InventoryCell;
